import React from 'react'
import SpecificComponent from '../../commons/SpecificComponent'
import AppBar from '../../commons/AppBar'
import LocalStorage from '../../providers/LocalStorage'
import Hidden from '@material-ui/core/Hidden';
import { Typography, TextField, Button, Grid, Select, FormControl, Input, MenuItem, InputLabel, Switch, FormControlLabel, Divider } from '@material-ui/core';
import Commons from '../../commons/Commons';
import Menu from '../../commons/Menu'
import Ws from '../../providers/Ws';
import AlertDialog from '../../commons/dialogs/AlertDialog'
import FromServer from '../useri/FromServer';

export default class Settings extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            theme: new LocalStorage().GetUserPreferences().theme,
            appBarButtons: this.buildAppBarButtons(),
            openMenu: false,
            objUserData:{},
            isOpenAlert:false

        }
    }

    testAdauga = () => {
        // console.log('Test adauga produs is fired = ')
    }

    testEdit = () => {
        // console.log('Test edit produs is fired = ')
    }

    componentDidMount(){
      this.getUserData()
    }

    handleChange= n => ev =>{
        let clone = {...this.state.objUserData}

        clone[n] = ev.target.value

        this.setState({objUserData:clone})
    }

    handleChecked = n => async ev => {
        let clone = {...this.state.objUserData}

        clone[n] = ev.target.checked === true ? 1 : 0

        let objToUpdate = {
            
        }

        objToUpdate[n] =  ev.target.checked === true ? 1 : 0

        // console.log('objToUpdate :', objToUpdate);
        
        let ls = new LocalStorage()

        let fs = new FromServer();



        let update = await fs.updateUser(objToUpdate, ls.GetUserData().InfoUser.IdUser)

        this.setState({objUserData:clone})
    }

    getUserData= async()=>{
        let ls = new LocalStorage()

        let ws = new Ws()

        // console.log('ls.getUserData() :', ls.GetUserData());

        let getUser = await ws.customSelect('select * from useri where id = @p1',{
            p1:ls.GetUserData().InfoUser.IdUser
        })

        // console.log('getUSer :', getUser);

        if(getUser.Succes){
            this.setState({objUserData:getUser.Content[0]})
        }

    }

    updateUser = async ()=>{

       
        let objToUpdate = {
            nume:this.state.objUserData.nume,
            telefon:this.state.objUserData.telefon,
            email:this.state.objUserData.email   
        }


        let ls = new LocalStorage()
        let fs = new FromServer();



        let update = await fs.updateUser(objToUpdate, ls.GetUserData().InfoUser.IdUser)


    }


    buildAppBarButtons = () => {

        let buttons = [
            {
                onClick: this.schimbaLimba,
                text: this.userPreferences.language === 'ro' ? 'EN' : 'RO',
                icon: ''
            },
            // {
            //     onClick: this.testAdauga,
            //     text: this.dictionary.comune.edit,
            //     icon: 'edit'
            // },
            {
                onClick: this.openTheme,
                text: this.dictionary.comune.theme,
                icon: ''
            },
        ]

        let C = new Commons()

        return C.generateAppBarButtons(buttons)
    }


    openTheme = () => {
        this.setState({ openMenu: true })
    }

    closeMenu = (e) => {
        // console.log('theme :', e);

        if (e !== null) {

            this.setState({ openMenu: false }, this.schimbaTema(e.id))
        } else {
            this.setState({ openMenu: false })
        }
    }

    schimbaLimba = () => {

        let succes = null;
        let LS = new LocalStorage()

        if (this.userPreferences.language === 'ro')
            succes = LS.SetUserPreferences('language', 'en')
        else
            succes = LS.SetUserPreferences('language', 'ro')

        // console.log('Succes schimbare limba = ', succes)

        if (succes) {
            document.location.reload();
        }
        else {
            console.error("Eroare schimbare limba")
        }
    }

    resetPrefs = () => {
        let LS = new LocalStorage()
        let succes = LS.SetDefaultPreferences()

        if (succes) {
            document.location.reload();
        }
        else {
            console.error("Eroare resetare default preferences")
        }
    }

    schimbaTema = (ev) => {
        let LS = new LocalStorage()
        let succes = LS.SetUserPreferences('theme', ev)
        if (succes) {
            console.info('console.info says: succes schimbare tema')
            document.location.reload();
        }
        else {
            console.error('Eroare schimbare tema')
        }

        document.location.reload();
    }

    render() {
        return (
            <div>
                <AppBar
                    history={this.props.history}
                    title={this.dictionary.settings.title}
                    appBarButtons={this.state.appBarButtons}
                />
                <div style={{ position: 'absolute', right: 0, top: 40 }}>
                    <Menu
                        openMenu={this.state.openMenu}
                        elSelectat={{ id: 1 }}
                        e={{ id: 1 }}
                        el={[{ id: 'light', text: 'Light' }, { id: 'dark', text: 'Dark' }]}
                        text='text'
                        closeMenu={this.closeMenu} />

                </div>

                 <Grid container className="container" >

                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                <h1 className='pm-title'>{this.state.objUserData.nume}</h1>
                <Divider className='pm-divider'/>
                </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={4} xl={4} >
                        <TextField
                            className="loginTextField inputFocus"
                            id="with-placeholder"
                            label={this.dictionary.settings.nume}
                            margin="normal"
                            value={this.state.objUserData.nume || ''}
                            onChange={this.handleChange('nume')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} xl={4} >
                        <TextField
                            className="loginTextField inputFocus"
                            id="password-input"
                            label={this.dictionary.settings.email}
                            type="text"
                            margin="normal"
                            value={this.state.objUserData.email || ""}
                            onChange={this.handleChange('email')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} xl={4} >
                        <TextField
                            className="loginTextField inputFocus"
                            id="password-input"
                            label={this.dictionary.settings.telefon}
                            type="number"
                            margin="normal"
                            value={this.state.objUserData.telefon || ""}
                            onChange={this.handleChange('telefon')}
                        />
                        
                    </Grid>
                     <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="loginButton" >
                        <Button variant="outlined" className='pm-save-button' color="primary" onClick={this.updateUser}>
                            {this.dictionary.comune.save}
                        </Button>


                    </Grid> 
               
                </Grid>  

                  

            <Grid container className="container" >
            <Divider className="pm-divider" />
                <Grid className='pm-switch-container' item xs={12} sm={12} md={6} lg={6} xl={6} >
                            <Switch
                                        className={this.state.objUserData.access_proiecte !== 1 ? '' : "pm-switch"}
                                            checked={this.state.objUserData.access_proiecte !== 1 ? false : true}
                                            onChange={this.handleChecked('access_proiecte')}
                                            value='companie'
                                        />
                                        <span className='pm-switch-label'>{this.dictionary.settings.accessProjects}</span>         
                    </Grid>

                    <Grid className='pm-switch-container' item xs={12} sm={12} md={6} lg={6} xl={6} >
                            <Switch
                                        className={this.state.objUserData.creaza_proiecte !== 1 ? '' : "pm-switch"}
                                            checked={this.state.objUserData.creaza_proiecte !== 1 ? false : true}
                                            onChange={this.handleChecked('creaza_proiecte')}
                                            value='companie'
                                        />
                                        <span className='pm-switch-label'>{this.dictionary.settings.createProjects}</span>         
                    </Grid>

                    <Grid className='pm-switch-container' item xs={12} sm={12} md={6} lg={6} xl={6} >
                            <Switch
                                        className={this.state.objUserData.modifica_angajati !== 1 ? '' : "pm-switch"}
                                            checked={this.state.objUserData.modifica_angajati !== 1 ? false : true}
                                            onChange={this.handleChecked('modifica_angajati')}
                                            value='companie'
                                        />
                                        <span className='pm-switch-label'>{this.dictionary.settings.modifyEmployees}</span>         
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="loginButton" >
                        <Button variant="outlined" className='pm-delete-button' color="primary" onClick={()=>{this.setState({isOpenAlert:true})}}>
                            {this.dictionary.settings.deactivateAccount}
                        </Button>


                    </Grid> 
                   
              
              </Grid>

              <AlertDialog
                    open={this.state.isOpenAlert}
                    dialogClose={()=>{this.setState({isOpenAlert:false})}}
                    title={this.dictionary.settings.alertDeactivate}
                    limba={this.dictionary}
                    yesFunction = {this.dezactiveazaCont}
                    />




            </div>
        );
    }


}  // end class